<template>
  <a class="download-link hovertext" :href="href" target="_blank">
    <div class="title-container">
      <p class="break-all my-4">{{ title }}</p>
    </div>
    <div class="size-container">
      <div class="flex w-full">
        <div class="flex-auto py-2 pl-3 w-4/6 text-sm">
          {{ size }}
        </div>
        <div class="flex-auto p-2 w-2/6 text-right">
          <i class="icon far fa-arrow-to-bottom fa-lg mr-1"></i>
        </div>
      </div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    href: {
      type: String,
      required: true
    },

    size: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~stylesheets/vars";

.download-link {
  display: inline-block;
  width: 100%;
  max-width: 12rem;

  @screen lg {
    max-width: 100%;
  }

  .title-container {
    background: $itau-light-gray;
    @apply h-24;
    @apply flex;
    @apply flex-col;
    @apply justify-center;
    @apply p-4;
    @apply rounded-t-md;
  }

  .size-container {
    background: #dddddd;
    @apply w-full;
    @apply h-10;
    @apply rounded-b-md;

    .icon {
      color: $blue-light;
    }
  }
}

</style>
